import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/api/client";
import { useAuth } from "@/auth/AuthContext";
import type { OrganizationResponse } from "@/models/usage";

async function fetchOrganization(): Promise<OrganizationResponse> {
  const { data } = await apiClient.get<OrganizationResponse>("/organization");
  return data;
}

export function useOrganization() {
  const { token } = useAuth();
  return useQuery<OrganizationResponse>({
    queryKey: ["organization", token],
    queryFn: fetchOrganization,
    enabled: !!token,
    refetchInterval: 60_000,
  });
}
